<template>
    <Toast/>
    <AcceptTermsDialog v-model="showTermsDialog" :terms="notAcceptedTerms" @checkTerms="getNotAccepted" />
    <div id="vue-app">
        <router-view :key="$route.path"/>
    </div>
</template>
<script>
    import Toast from "primevue/toast";
    import { ThemeSettingsHelper } from "@/mixins/themeSettings";
    import AcceptTermsDialog from "./views/terms/AcceptTermsDialog";
    import {
        getNotAcceptedTerms,
    } from "@/swagger/vue-api-client";

    export default {
        components: {
            Toast,
            AcceptTermsDialog,
        },
        data() {
            return {
                watchRoute: true,
                showTermsDialog: false,
                notAcceptedTerms: [],
            };
        },
        beforeCreate() {
            ThemeSettingsHelper.checkLocalStorage();
        },
        methods: {
            getNotAccepted() {
                getNotAcceptedTerms()
                    .then((response) => {
                        if (response.data && response.data.length > 0) {
                            this.showTermsDialog = true;
                            this.notAcceptedTerms = response.data;
                        } else {
                            this.showTermsDialog = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
        },
        watch: {
            "$route.name"(val) {
                if (val === "login" || val === "remindPassword" || val === "register" || val === "changePassword") return;
                if (JSON.parse(localStorage.getItem("checkTerms"))) {
                    this.getNotAccepted();
                    localStorage.removeItem("checkTerms");
                }
                if (val && this.watchRoute) {
                    this.watchRoute = false;
                    this.getNotAccepted();
                }
            },
        },
    };
</script>

<style lang="scss">
</style>
